import React, { Component } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

import styles from "./RadioGroupOption.css";

export default class RadioGroupOption extends Component {
  render() {
    const checked = this.props.selectedValue === this.props.value;
    return (
      <label
        className={classNames(styles.root, { [styles.isChecked]: checked })}
      >
        <input
          type="radio"
          checked={checked}
          name={this.props.name}
          value={this.props.value}
          onChange={this.props.onChange}
        />
        <span className={styles.label}>{this.props.label}</span>
      </label>
    );
  }
}

RadioGroupOption.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  selectedValue: PropTypes.string, // passed from RadioGroup automatically
  onChange: PropTypes.func, // passed from RadioGroup automatically
};
